module.exports = __webpack_public_path__ + "img/hackernews.ad644a42.jpg";